import { Outlet } from 'react-router-dom'

import Fourthgrade_k4_subjects from './fourthgrade_k4_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Fourthgrade_k4 = ( ) => {
 
  return (
    <>
   
   
  <TopNavbar />
  <Fourthgrade_k4_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Fourthgrade_k4;